export default () => (
  <svg width="250" height="180" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M58.913 179h51.312c11.532 0 16.394-2.89 13.647-6.963-4.991-7.394-63.095 1.341-63.095 1.341L58.92 179h-.007Z"
      fill="#000"
      stroke="#000"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="m46.642 150.694-3.205 3.643c-1.399 1.47 1.527 4.963 3.514 3.471l3.758-3.091" fill="#fff" />
    <path
      d="m46.642 150.694-3.205 3.643c-1.399 1.47 1.527 4.963 3.514 3.471l3.758-3.091"
      stroke="#000"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M142.697 17.928c.66-3.199 2.338-8.183 6.928-9.036.093-.015.093-.15 0-.165-4.245-.725-5.629-3.457-6.634-7.875-.021-.093-.15-.086-.164 0-.883 4.748-3.278 7.695-7.165 8.305-.093.014-.093.143 0 .165 3.765.983 5.967 5.415 6.885 8.606.021.086.143.079.165 0h-.015ZM193.859 56.338c-1.097 2.99-4.726 7.559-9.997 9.28-.201.065-.179.273.029.316 4.805.932 8.003 6.504 8.899 8.261.079.158.381.144.438-.014 1.908-5.307 7.903-7.53 9.768-8.104.193-.057.186-.25 0-.308-5.006-1.492-7.495-6.354-8.692-9.424-.065-.165-.38-.165-.445 0v-.007Z"
      fill="#fff"
      stroke="#000"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M108.037 172.718c-4.74-3.88-13.339-8.929-23.824-35.055a3.211 3.211 0 0 1 1.213-3.879l7.436-4.891-18.689-18.983-27.294 37.435c-2.23 3.722 3.37 9.33 7.085 7.1l12.6-8.276c.467-.309 1.04.201.79.695-4.01 8.09-10.579 21.321-12.049 24.032-2.151 3.966-3.47 8.097 1.987 8.097h11.962c3.966 0 5.12-.803 5.586-1.599 1.298-2.231-1.255-4.511-4.008-7.624-4.726-5.342 2.76-22.927 5.407-28.686.315-.688 1.312-.652 1.57.065 2.56 6.992 11.331 30.945 12.034 33.06.825 2.482.66 4.791 5.953 4.791h9.444c3.773 0 7.43-2.481 2.783-6.282h.014Z"
      fill="#000"
      stroke="#000"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M108.037 172.717c-2.66-2.172-6.54-4.718-11.28-11.158 2.976 4.41-9.101 6.511-10.09 3.786 1.656 4.561 2.94 8.104 3.19 8.857.825 2.481.66 4.791 5.953 4.791h9.445c3.772 0 7.43-2.482 2.782-6.283v.007ZM74.855 177.401c1.298-2.231-1.255-4.511-4.009-7.624-1.29-1.455-1.664-3.829-1.484-6.626-.41 7.014-11.733 3.27-10.09 0-1.837 3.657-3.335 6.626-3.952 7.752-2.152 3.966-3.471 8.097 1.986 8.097h11.962c3.966 0 5.12-.803 5.587-1.599Z"
      fill="#fff"
      stroke="#000"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M61.265 107.765c2.395-3.227 8.513.165 5.866 4.461l-12.894 16.832c-1.986 2.675-7.2-.789-4.554-5.078l11.575-16.215h.007Z"
      fill="#000"
      stroke="#000"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M57.837 132.342v-7.968c0-5.12 3.471-6.124 3.471-4.532v7.738l-3.47 4.755v.007ZM159.974 14.034a.94.94 0 0 0-1.391.114l-7.903 10.464c-2.812 2.811-4.461 16.38 4.561 25.538 9.595 9.738 20.582 8.548 24.218 6.074l12.98-11.64-32.458-30.557-.007.007Z"
      fill="#fff"
      stroke="#000"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m148.578 35.642 7.064-6.878"
      stroke="#000"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m192.432 44.592-21.522-20.26-12.148 12.486-7.695 7.501a22.99 22.99 0 0 0 4.173 5.845c9.596 9.739 20.583 8.548 24.219 6.074l12.98-11.64-.007-.006Z"
      fill="#000"
      stroke="#000"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M165.761 7.78c-27.775 16.358 5.902 57.164 26.671 36.811 19.413-19.011-8.57-47.482-26.671-36.81Z"
      fill="#00D64F"
      stroke="#000"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M177.372 15.002c-.954-1.248-2.611-1.85-4.181-1.729-1.571.122-3.034.89-4.21 1.93-1.585 1.405-2.711 3.42-2.711 5.536.007 3.155 2.869 6.024 6.024 6.038 3.069.015 5.744-2.259 8.8-2.539 3.858-.358 7.573 2.955 7.96 6.813.387 3.859-2.338 7.703-6.017 8.929-3.414 1.14-7.745-.165-9.237-3.442"
      stroke="#000"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M185.511 38.783c.897 1.29 1.793 2.574 2.697 3.858M167.446 11.402c.674 1.083 1.356 2.159 2.037 3.234"
      stroke="#000"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m79.222 115.03-5.041-5.12-27.295 37.435c-.846 1.406-.509 3.428.308 4.504l29.49-34.71 2.538-2.116v.007Z"
      fill="#00D64F"
      stroke="#000"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M100.808 63.309 76.626 98.672c-10.413 16.695 12.916 37.858 26.449 27.775 0 0 27.345-18.768 34.287-24.713 15.87-12.142 17.677-29.64 8.197-42.305-13.519-18.058-33.255-13.963-44.758 3.887l.007-.007Z"
      fill="#fff"
      stroke="#000"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M145.566 59.429c-13.518-18.058-33.254-13.963-44.757 3.887-14.666 21.45 13.697 55.199 36.56 38.418 15.87-12.142 17.678-29.64 8.197-42.305Z"
      fill="#00D64F"
      stroke="#000"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M103.433 76.003c6.806-9.998 23.351-18.123 34.287.093.338.566.359 1.27.051 1.85-7.38 13.898-25.94 13.82-34.381.079a1.878 1.878 0 0 1 .043-2.022Z"
      fill="#fff"
      stroke="#000"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M128.268 66.773c-5.113-2.46-10.599-.244-12.457 4.963-1.857 5.206 1.162 9.316 4.741 10.535 3.514 1.197 8.075.043 10.133-4.317 2.123-4.49 1.37-9.36-2.417-11.188v.007Z"
      fill="#000"
      stroke="#000"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M101.877 61.724c7.602-9.983 27.804-13.504 37.873 2.733 11.596 18.696-4.167 44.104-23.903 40.138 6.727 2.69 14.386 2.367 21.515-2.861 15.87-12.141 17.678-29.64 8.197-42.305-13.11-17.505-32.064-14.192-43.682 2.295Z"
      fill="#000"
      stroke="#000"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M61.272 107.758 49.69 123.98c-1.29 2.094-.71 3.988.452 5.07.05.043.129.036.165-.021l13.188-19.019s-1.484-3.299-2.223-2.259v.007Z"
      fill="#00D64F"
      stroke="#000"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M61.265 107.765c-2.897 4.06 2.976 7.853 5.866 4.461 2.647-4.296-3.47-7.688-5.866-4.461ZM164.341 84.314c-.939 3.65-4.059 9.23-8.577 11.331-.172.08-.15.337.029.388 4.123 1.14 6.863 7.938 7.637 10.09.065.186.33.172.373-.022 1.635-6.475 6.785-9.194 8.384-9.896.165-.072.158-.309 0-.38-4.296-1.822-6.426-7.76-7.459-11.504-.057-.2-.329-.2-.38 0l-.007-.007Z"
      fill="#fff"
      stroke="#000"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
